const tireSizeSelectionEl = document.getElementById('js-tireSizeSelectionEl');
const tireSizesSelectEl = document.getElementById('js-tireSizesList');
const priceEl = document.getElementById('js-tirePrice');

export default function() {
  updatePrice();
  if (tireSizesSelectEl) {
    tireSizesSelectEl.addEventListener('change', updatePrice);
  }

  function updatePrice() {
    if (!tireSizesSelectEl) {
      return;
    }
    const tireSizesSelectValue = tireSizesSelectEl.value;
    priceEl.textContent = parseFloat(sizePrice[tireSizesSelectValue]).toFixed(2);
  }
}

